import { render, staticRenderFns } from "./outlet_name_history_index.vue?vue&type=template&id=5680fa82&scoped=true&"
import script from "./outlet_name_history_index.vue?vue&type=script&lang=js&"
export * from "./outlet_name_history_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680fa82",
  null
  
)

export default component.exports